import { SWRConfiguration } from 'swr';

import { UseArraySWROutput, useArraySWR } from '~/hooks/useSWR';
import { getCurrentLanguage } from '~/localization';
import { fetchFromOldApi } from '~/services/Http';

export type UpCustomData = {
  code: string;
  description: string;
  name: string;
  seq: number;
};

//TODO: THINK ABOUT COUNTRY FILTER
export const getCustomDataUnitPosition = async (): Promise<UpCustomData[]> => {
  const currentLanguage = getCurrentLanguage();
  return await fetchFromOldApi(
    `/json/enum/CUSTOM_ENTITY_UNIT_POSITION/${currentLanguage}?includeInactive=false`,
  ).then((r) => r.json());
};

export const useGetUnitPositionCustomData = (
  swrConfig?: SWRConfiguration,
): UseArraySWROutput<UpCustomData> => {
  return useArraySWR(
    'useGetUnitPositionCustomData',
    () => getCustomDataUnitPosition(),
    swrConfig,
  );
};
